import React from 'react';
import Card from '../components/UI/Card';
import { PageTransition } from '@/components/motion';

function Sherlock() {
  return (
    <PageTransition className="p-6">
      <Card>
        <div className="text-center py-20">
          <div className="text-6xl mb-4">🔍</div>
          <h2 className="text-2xl font-bold text-foreground mb-2">Sherlock</h2>
          <p className="text-muted-foreground mb-1 max-w-md mx-auto">
            AI-powered market analyser that helps you understand markets, identify patterns, and make informed decisions.
          </p>
          <p className="text-sm text-muted-foreground/60 mt-4">Coming soon</p>
        </div>
      </Card>
    </PageTransition>
  );
}

export default Sherlock;
